import _ from 'lodash';

class FormValidator {
    /**
     * Unset all keys in rules object and set new rules
     *
     * @return rules
     */
    static getRules (rules, errors) {
        _.forEach(rules, (rule, key) => {
            _.unset(rules, key);
        });

        _.forEach(errors, (messages, key) => {
            rules[key] = [
                {
                    validator: (rule, value, callback) => {
                        callback(new Error(messages[0]));
                    },
                    trigger: 'blur'
                }
            ];
        });

        return rules;
    }

    /**
     * Reset the current validation and validate the form.
     */
    static validate (formRef, data, rules, errors = []) {
        let oldData = _.cloneDeep(data);

        formRef.resetFields();
        this.getRules(rules, errors);
        formRef.validate()
            .then(() => {})
            .catch(() => {});

        _.forEach(oldData, (value, key) => {
            _.set(data, key, value);
        });
    }
}

export { FormValidator };
